import { Component, input } from '@angular/core';

@Component({
  selector: 'app-chevron-down-icon',
  imports: [],
  templateUrl: './chevron-down-icon.html',
  styleUrl: './chevron-down-icon.scss',
})
export class ChevronDownIcon {
  width = input<string | number>(16);
  height = input<string | number>(16);
  strokeWidth = input<string | number>(2);

}
